import { connect } from 'react-redux';
import { compose } from 'recompact';

import type { RootState } from 'src/app/state/store';

import { PharmacySearch } from '../../../PharmacySearch/container';
import { Step } from '../../StepLayout/Step';

const PreviousPharmacyStepRenderer = ({ handleNextClick, setShowFooter, onboardingForm }) => {
  return (
    <Step title={'Which pharmacy has your prescriptions?'} customHandlePrevText={'Back'}>
      <PharmacySearch
        handleNextClick={handleNextClick}
        setShowFooter={setShowFooter}
        transferForm={onboardingForm}
        isOnboarding
      />
    </Step>
  );
};

const mapStateToProps = (state: RootState) => {
  const onboardingForm = state.onboardingForm;

  return {
    onboardingForm,
  };
};

const connector = connect(mapStateToProps, null);

export const PreviousPharmacyStep = compose(connector)(PreviousPharmacyStepRenderer);
